import { ref } from 'vue'

export interface VersionInfo {
  frontend_version: string
  backend_version?: string
}

const versionInfo = ref<VersionInfo | null>(null)
let loaded = false

async function loadVersionInfo() {
  if (!loaded) {
    try {
      const response = await fetch('/version.json')
      if (!response.ok) {
        throw new Error('Version metadata unavailable')
      }
      versionInfo.value = await response.json()
    } catch (err) {
      console.warn('Could not load frontend version info:', err)
      versionInfo.value = null
    }
    loaded = true
  }
}

export function useVersionInfo() {
  return { versionInfo, loadVersionInfo }
}
